export const ABOUT = {
  careers: "https://api.manatal.com/open/v3/career-page/eastwest-bank/jobs/",
};

export const ACQUIRED_ASSETS = {
  acquiredVehiclesPage: "/data/acquired-assets/auto-loans-second-hand.json",
  acquiredVehicleList: "/sale-use-car",
  acquiredPropertiesPage: "/data/acquired-assets/properties-for-sale.json",
  acquiredPropertiesList: "/market-properties",
};

export const BONDS = {
  topBondsPicks: "/topbondspicks",
  topBondsPicksSubtext: "/topbondspickssubtext",
};

export const BUSINESS_COMPLETE_SOLUTIONS = {
  completebusinessbanner: "completebusinessbanner",
  completebusinessSolution: "businesscompletedetail",
};

export const CREDIT_CARDS = {
  banner: "creditcardbanner",
  benefits: "creditcardbenefitsadvantage",
  cardContents: "/data/creditcards/creditcard.json",
  list: "creditcardslist",
};

export const DEPOSIT = {
  depositaccountlist: "depositaccountlist",
};

export const DXP_LANDING = {
  main: "/dxp/page",
  features: "/dxp/page/features/", //qs: ids [comma separated]
  faqs: "/dxp/page/faqs/", //qs: ids [comma separated]
  faqQuestions: "dxp/page/faqs/item/",
  userGuide: "/dxp/page/guide/", //qs: ids [comma separated]
  regStep: "dxp/page/regstep/", //qa: ids [comma separated]
};

export const FEATUREDLIST = {
  list: "/featuredlist",
};

export const HOME_PAGE = {
  advisoriesList: "advisorieslist",
  homepageProductBanner: "homepage-feature-banner/",
  carouselList: "homepagebanners",
  latest_news: "/newsList",
  quicklinks: "api/product-quick-menu",
};

export const BANNER = {
  holiday_banner: "/holiday-banner",
};

export const INVESTMENT = {
  investmentLandingPage: "/investmentsproductcatlist",
  investementProductDetails: "investmentproductdetails",
};

export const MOBILE_CHECK_DEPOSIT = {
  landingPage: "data/eastwestMobileCheckDeposit.json",
};

export const RATES = {
  autoLoansBrandNew: "/autoloanbrandnew",
  autoLoansSecondHand: "/autoloansecondhand",
  personalLoanRatesWithCC: "/personalloanrateswithcc",
  personalLoanRatesWithoutCC: "/personalloanrateswithoutcc",
  pesoTimeDepositRates: "/pesotimedepositrate/",
  longTermPesoTimeDepositRates: "/longtermpesotimedepositrate/",
  longTermPesoRateFloating: "/longtermpesoratefloating/",
  usdTimeDepositRate: "/usdtimedepositrate/",
  longTermUsdTimeDepositRate: "/longtermusdtimedepositrate/",
  rmbTimeDepositRate: "/rmbtimedepositrate/",
  euroTimeDepositRate: "/eurotimedepositrate/",
  timeDepositRateValidity: "/timedepositratesvalidity/",
  pesoSavingRate: "/pesosavingsrate/",
  pesoCheckingRate: "/pesocheckingrate/",
  foreignCurrencySavingsRate: "/foreigncurrencysavingsrate/",
  homeLoanRates: "/homeloanrates",
  jpyTimeDepositRates: "/jpytimedepositrate",
  sgdTimeDepositRates: "/sgdtimedepositrate",
  audTimeDepositRates: "/audtimedepositrate",
  tierredDepositRates: "tiereddepositrate/",
};

export const REQUEST_FOR_CALLBACK = "sendcustomemail";

export const TRUST_PRODUCTS_AND_SERVICES = {
  landingPage: "/data/investments/trustproductsandserviceslanding.json",
  fixedIncome: "/data/investments/fixed-income-product.json",
};

export const UITF = {
  listOfProducts: "/data/investments/unitinvestmenttrustfunds/products.json",
  navpuItems: "/data/investments/unitinvestmenttrustfunds/navpu.json",
  listOfRequirements:
    "/data/investments/unitinvestmenttrustfunds/listOfRequirements.json",
  otherToolsAndResources:
    "/data/investments/unitinvestmenttrustfunds/otherToolsAndResources.json",
};

export const OTHER_SERVICES = {
  EwBillers: "/api/ewbillers",
};
export const NAVIGATION_MENU = {
  personalMenu: "/menu_items/personal-main-menu",
  businessMenu: "/menu_items/business-main-menu",
  aboutUsMenu: "/menu_items/about-us-menu",
  customerSupportMenu: "/menu_items/customer-support-menu",
  footerSitemap: "/menu_items/footer-menu",
};
